<template>
  <span>
    <span v-for="(segment, index) in segments" :key="index">
      <span v-if="segment.match" class="text-blue-300 bg-blue-100">{{
        segment.match
      }}</span>
      <span v-if="segment.rest">{{ segment.rest }}</span>
      <pre
        v-if="index < segments.length - 1"
        class="inline p-0 m-0 font-sans bg-transparent border-none ds-text-sm font-semibold text-gray-900"
      >
&nbsp;</pre
      >
    </span>
  </span>
</template>

<script>
import _ from "lodash";
import maxBy from "lodash/maxBy";

export default {
  props: {
    parts: { type: Array, required: true },
    query: { type: String, required: true },
  },

  computed: {
    segments() {
      const resultParts = this.parts;
      const queryParts = this.query.split(/\s+/);

      return resultParts.map((resultPart) => {
        const bestMatch = findBestMatch(resultPart, queryParts);

        return {
          match: bestMatch,
          rest: resultPart.substring(bestMatch.length),
        };
      });
    },
  },
};

function findBestMatch(resultPart, queryParts) {
  const best = maxBy(
    queryParts.map((queryPart) => intersectStrings(resultPart, queryPart)),
    (part) => part.length
  );

  return best || "";
}

function intersectStrings(a, b) {
  let result = "";
  let i = 0;

  while (
    i < a.length &&
    i < b.length &&
    a.charAt(i).toLowerCase() === b.charAt(i).toLowerCase()
  ) {
    i++;
  }

  return a.substring(0, i);
}
</script>